// extracted by mini-css-extract-plugin
export default {"container":"wrapper_container__3bpyr","dashboardcontainer":"wrapper_dashboardcontainer__kmDSF","upperImg":"wrapper_upperImg__eK4hO"};